var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"items":_vm.items}}),_c('p',[_vm._v(_vm._s(_vm.$t('app.messages')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }